// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IDocumentFileSchema } from './DocumentFileSchema';
import type { IImageFileSchema } from './ImageFileSchema';
import type { IImageFileAsDocumentSchema } from './ImageFileAsDocumentSchema';

export interface IMessageListFilesSchema {
  /**
   *
   *     Файлы переданный в виде документов без изменений.
   *     Если они есть, то в поле file_types обязательно должен присутствовать тип document.
   *
   */
  documents?: IDocumentFileSchema[];
  /**
   *
   *     Множество уникальных типов файлов, присутствующих в данной структуре. Требуется для того, чтобы клиенты могли
   *     определить, есть ли в списке неподдерживаемые типы файлов и оповестить об этом пользователей. Требуется ввиду того,
   *     что информация о разных типов файлов может храниться в разных структурах внутри данного ответа.
   *
   */
  fileTypes: EFileTypes[];
  /** Файлы изображений, если они есть, то в поле file_types обязательно должен присутствовать тип image **/
  images: IImageFileSchema[];
  /**
   *
   *     Файлы изображений, переданные как есть без изменений.
   *     Если они есть, то в поле file_types обязательно должен присутствовать тип image_as_document.
   *
   */
  imagesAsDocuments?: IImageFileAsDocumentSchema[];
}
export enum EFileTypes {
  /**
   *
   *     Любой другой файл, которые можно загружать в чат, такой файл нельзя как-то изменять,
   *     используется таким каким был при загрузке.
   *
   */
  'Document' = 'document',
  /**
   *
   *     Картинки, фотографии, другие изображения.
   *     Файл с таким типом может отличаться от изначального загруженного, так как основной смысл в изображении, а не в том
   *     какой файл для этого используется.
   *
   */
  'Image' = 'image',
  /**
   *
   *     Изображение в виде файла, то есть такое изображение нельзя как-то изменять,
   *     используется таким каким было при загрузке.
   *
   */
  'ImageAsDocument' = 'imageAsDocument',
}
